var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef, useMemo } from 'react';
import AntdIcon from '@ant-design/icons';
import classNames from 'classnames';
import usePrefixCls from '../hooks/usePrefixCls';
const transformToStrikeStyle = (name) => {
    return name
        .replace(/^(.*)Icon$/, 'Icon$1')
        .replace(/([A-Z]|[0-9]+)/g, (_, $1) => {
        return '-' + $1.toLowerCase();
    })
        .replace(/-+/g, '-')
        .replace(/^-/, '');
};
const IconBase = forwardRef((props, ref) => {
    const { prefixCls: customizePrefixCls, type, children, className, spin, onClick, disabled, colorType = 'default' } = props, rest = __rest(props, ["prefixCls", "type", "children", "className", "spin", "onClick", "disabled", "colorType"]);
    const prefixCls = usePrefixCls('icon', customizePrefixCls);
    const mergedClassNames = useMemo(() => {
        const feedback = typeof onClick === 'function';
        return classNames(prefixCls, `${prefixCls}-${colorType}${feedback ? '-feedback' : ''}`, {
            [`${prefixCls}-disabled`]: disabled
        }, {
            [`${prefixCls}-spin`]: spin
        }, className);
    }, [className, colorType, disabled, onClick, spin, prefixCls]);
    let content = null;
    // 将驼峰式的命名转化为中划线式的命名
    const realType = useMemo(() => {
        if (type) {
            let resType = transformToStrikeStyle(type);
            if (resType.indexOf('icon-') === -1) {
                resType = `icon-${resType}`;
            }
            return resType;
        }
    }, [type]);
    if (type) {
        content = React.createElement("use", { xlinkHref: `#${realType}` });
    }
    if (children) {
        content = children;
    }
    return (React.createElement(AntdIcon, Object.assign({}, rest, { ref: ref, className: mergedClassNames, onClick: onClick }), content));
});
IconBase.displayName = 'YsdIcon';
export default IconBase;
